<template>
  <validation-provider
    v-slot="{ errors }"
    :name="fieldName"
    :rules="rules"
  >
    <v-autocomplete
      :items="datasource"
      :error-messages="errors"
      :filter="customFilter"
      color="blue"
      item-text="name"
      item-value="id"
      :disabled="disabled"
      :label="$t('fields.'+(label !== '' ? label : fieldName) )"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template
        slot="selection"
        slot-scope="data"
      >
        <!-- HTML that describe how select should render selected items -->
        {{ translate ? $t('types.'+data.item.name) : data.item.name }}
      </template>
      <template
        slot="item"
        slot-scope="data"
      >
        <!-- HTML that describe how select should render items when the select is open -->
        {{ translate ? $t('types.'+data.item.name) : data.item.name }}
      </template>
    </v-autocomplete>
  </validation-provider>
</template>

<script>
  // Utilities
  import { call } from 'vuex-pathify'

  export default {
    name: 'DataSelector',

    props: {
      fieldName: String,
      label: {
        type: String,
        default: '',
      },
      sourceType: String,
      translate: Boolean,
      disabled: Boolean,
      sorted: Boolean,
      filter: {
        type: String,
        default () {
          return ''
        },
      },
      alter: String,
      rules: {
        type: String,
        default () {
          return 'required'
        },
      },
      customSource: {
        type: Array,
        default: () => ([]),
      },
    },

    data () {
      return {
        datasource: [],
      }
    },
    computed: {
      sortedItems () {
        const sortedArray = [...this.datasource]
        sortedArray.sort((a, b) => {
          let comparison = 0
          if (this.$t(a.name) < this.$t(b.name)) {
            comparison = -1
          } else if (this.$t(a.name) > this.$t(b.name)) {
            comparison = 1
          }
          return comparison
        })
        return sortedArray
      },
    },
    mounted () {
      console.log(this.datasource)
      if (this.sourceType === 'custom') {
        this.datasource = this.customSource
      } else {
        this.fetchDatasource({ sourceType: this.sourceType, filter: this.filter }).then(response => {
          if (this.filter !== '') {
            response = response.filter(f => f.category === this.filter || f.filter === this.filter)
          }
          // this.datasource = response
          if (this.sorted) {
            response = response.sort((a, b) => this.$t('types.' + a.name).toLowerCase() < this.$t('types.' + b.name).toLocaleLowerCase() ? -1 : 0)
          }
          this.datasource = response
        })
      }
    },
    methods: {
      fetchDatasource: call('datasource/fetchDatasource'),
      customFilter (item, queryText, itemText) {
        const text = item.name.toLowerCase()
        const alter = this.alter ? (item[this.alter] ? item[this.alter].toLowerCase() : '') : ''
        const cleanText = this.ignoreAccent(item.name.toLowerCase())
        const textTrans = this.$t('types.' + item.name).toLowerCase()
        const searchText = queryText.toLowerCase()
        return this.translate ? textTrans.indexOf(searchText) > -1 : text.indexOf(searchText) > -1 || alter.indexOf(searchText) > -1 || cleanText.indexOf(searchText) > -1
      },
      ignoreAccent (value) {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      },
    },
  }
</script>
